/* global SchedulerWidget */

const initButtons = () => {
	const buttons = document.querySelectorAll(
		'.cinch-button:not(.initialized)'
	);

	buttons.forEach((button) => {
		const cinchLocationID = button.dataset.cinchLocationId;

		if (!cinchLocationID) {
			return;
		}

		button.classList.add('initialized');

		button.addEventListener('click', (e) => {
			e.preventDefault();

			if (!window.SchedulerWidget) {
				return;
			}

			SchedulerWidget.show(
				'7799b3a0-dd62-4435-b945-b0fbf94e9d8c',
				'v1',
				cinchLocationID
			);
		});
	});
};

initButtons();

window.addEventListener('propel-filter-locations-loaded', initButtons);
